import { useCallback, useState } from "react";

import { fetchFxQuote, fetchWallets } from "./paymentsService";
import { mapFxQuote, mapWallet } from "./paymentsMappers";

const TOLERANCE = 0.005;

const useWalletPayment = () => {
  const [isChecking, setChecking] = useState(false);

  const check = useCallback(async ({ amount, currency }) => {
    setChecking(true);

    try {
      const data = await fetchWallets();
      const wallets = (data?.wallets || []).map(mapWallet).filter(Boolean);
      const wallet = wallets.find((row) => row.currencyCode === currency) || wallets[0];

      if (!wallet) return { status: "no-wallet" };

      let debit = { value: amount, currency };

      if (wallet.currencyCode !== currency) {
        const quote = mapFxQuote(
          await fetchFxQuote({ from: currency, to: wallet.currencyCode, amount }),
          { from: currency, to: wallet.currencyCode, amount }
        );

        if (!quote) return { status: "no-rate" };

        debit = quote.convertedAmount;
      }

      if (wallet.balance.value + TOLERANCE < debit.value) {
        return {
          status: "insufficient",
          shortfall: { value: debit.value - wallet.balance.value, currency: debit.currency },
          wallet,
        };
      }

      return { status: "ok", walletCurrency: wallet.currencyCode, debit };
    } finally {
      setChecking(false);
    }
  }, []);

  return { isChecking, check };
};

export default useWalletPayment;
